<template>
  <div>
    <card class="card-tyle">
      <div class="row">

        <div class="col-12 div-form-style">
          <div class="title-form-style">Criar nova tag</div>
          <form class="row" @submit="onSubmit">

            <div class="col-6">
              <div class="sub-title-style">Nome da tag *</div>
              <input required type="text" v-model="name" class="form-control">
            </div>

            <div class="col-12">
              <div class="sub-title-style">Destinos(idi's) * <span class="obs-title-style">(Separados por vírgula)</span></div>
              <textarea required @keyup="countIdis" type="text" v-model="idis_destiny" class="form-control idis-style"></textarea>
            </div>

            <div v-if="idis_destiny" class="col-12 div-idis-affected">
              Aproximadamente <strong> {{estimate_of_idis_affected}} </strong> clientes afetados.
            </div>

            <div class="form-group col-12 btn-criar-style">
              <button class="btn btn-primary">Criar tag</button>
            </div>
          </form>
        </div>

      </div>
    </card>
  </div>
</template>

<script>

import axios from 'axios'
import { Card } from 'src/components'

export default {
    components: {
      Card,
    },
    data() {
      return {
        name: '',
        idis_destiny: '',
        estimate_of_idis_affected: null,
      }
    },
    props: [],
    methods: {
      countIdis() {
        if(this.idis_destiny) {
          this.idis_destiny = this.idis_destiny.toString().split(',')
        }
        this.estimate_of_idis_affected = this.idis_destiny.length
      },
      onSubmit(e) {
        e.preventDefault()

        if(this.idis_destiny) {
          this.idis_destiny = this.idis_destiny.toString().split(',')
        }

        let metadata = {
          name: this.name,
          color: null,
          parent_id: null,
          installations: this.idis_destiny,
        }

        axios.post(process.env.VUE_APP_NEST_CAMPAIGN + 'installation/tag', metadata).then(res => {
             this.$swal({
                type: "success",
                title:"Sucesso!",
                text:res.data.message,
                timer: 3000
            })
          this.$router.push('/tags-list')
        }).catch(err => {
          this.$swal({
            type: "error",
            title: "Ops... algo deu errado!",
            text: 'Verifique os campos preenchidos!',
            timer: 3000
          })
        });
      }

    },
    mounted() {
    }
}
</script>

<style lang="scss">
.div-form-style{
  height: 100%;
}

.title-form-style {
  color: #032351;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 10px;
}

.obs-title-style {
  font-weight: 400;
  font-size: 12px;
}

.idis-style {
  height: 150px !important;
  max-height: none !important;
}

.div-idis-affected {
  display: flex;
  justify-content: center;
  color: #3C5373;
  font-size: 14px;
  margin-top: 20px;

  strong {
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>
